
export function fixActivitiesParenting(activities) {
  // Step 1: Flatten the activities
  const flattenedActivities = flattenActivities(activities);

  // Step 2: Separate assessments by language
  const latestEnglishAssessments = filterLatestActivitiesByLanguage(
    flattenedActivities,
    true // English
  );

  const latestSpanishAssessments = filterLatestActivitiesByLanguage(
    flattenedActivities,
    false // Spanish
  );

  // Step 3: Map all related activities to the latest assessments
  const mappedEnglishAssessments = mapActivitiesToAssignments(
    flattenedActivities,
    latestEnglishAssessments,
    true // English
  );

  const mappedSpanishAssessments = mapActivitiesToAssignments(
    flattenedActivities,
    latestSpanishAssessments,
    false // Spanish
  );

  // Combine results for final output
  return [...mappedEnglishAssessments, ...mappedSpanishAssessments];
}

// Helper to convert assignmentId
function cleanAssignmentID(uuid, activity) {
  if (typeof uuid !== "string") {
    console.log("Invalid assignment ID from activity:", activity);
    return uuid;
  }
  return uuid.replace(/-/g, "").toUpperCase();
}

// Helper function to flatten activities
const flattenActivities = (activities) => {
  const flatActivities = [];

  const processActivity = (activity) => {
    if(activity.type === "tutor"){
      flatActivities.push({ ...activity, children: undefined });
    }else{
      activity.assignmentId = cleanAssignmentID(activity.assignmentId, activity);
      flatActivities.push({ ...activity, children: undefined });
      if (activity.children && activity.children.length > 0) {
        activity.children.forEach((child) => processActivity(child));
      }
    }
  };

  activities.forEach((activity) => processActivity(activity));
  return flatActivities;
};

// Helper function to filter latest assessments by language and status
const filterLatestActivitiesByLanguage = (activities, isEnglish) => {
  const filteredActivities = activities.filter(
    (activity) =>
      (isEnglish
        ? !activity.tags?.includes("ES_MX") // English activities do NOT have the ES_MX tag
        : activity.tags?.includes("ES_MX")) && // Spanish activities have the ES_MX tag
      (activity.status === "scored" ||
        activity.displayStatus === "prereader") && // Only consider scored or prereader
      (activity.type === "assessment" || activity.type === "tutor") // Only consider assessments or tutor activities
  );
  const latestActivities = filteredActivities.reduce((acc, activity) => {
    const key = activity.type === "tutor" ? activity.activityId : cleanAssignmentID(activity.assignmentId, activity);
    if (
      !acc[key] ||
      new Date(activity.createdAt) > new Date(acc[key].createdAt)
    ) {
      acc[key] = activity;
    }
    return acc;
  }, {});

  return Object.values(latestActivities);
};

// Helper function to map all related activities by assignment ID and language
const mapActivitiesToAssignments = (
  activities,
  latestAssessments,
  isEnglish
) => {
  return latestAssessments.map((latestAssessment) => {
    const children = activities.filter(
      (activity) =>
        activity.type !== "tutor" &&
        activity.assignmentId === latestAssessment.assignmentId &&
        activity.activityId !== latestAssessment.activityId && // Exclude the latest assessment itself
        (isEnglish
          ? !activity.tags || !activity.tags?.includes("ES_MX") // Match language: English
          : activity.tags?.includes("ES_MX")) // Match language: Spanish
    );

    return {
      ...latestAssessment,
      children,
    };
  });
};